var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loaded)?_c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"50"}})],1):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }